var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTherapySearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.172 33.1504C110.172 33.4265 110.396 33.6504 110.672 33.6504C110.948 33.6504 111.172 33.4265 111.172 33.1504L110.172 33.1504ZM111.172 29.9483C111.172 29.6722 110.948 29.4483 110.672 29.4483C110.396 29.4483 110.172 29.6722 110.172 29.9483L111.172 29.9483ZM110.172 23.5442C110.172 23.8204 110.396 24.0442 110.672 24.0442C110.948 24.0442 111.172 23.8204 111.172 23.5442L110.172 23.5442ZM111.172 17.1401C111.172 16.864 110.948 16.6401 110.672 16.6401C110.396 16.6401 110.172 16.864 110.172 17.1401L111.172 17.1401ZM110.172 10.736C110.172 11.0121 110.396 11.236 110.672 11.236C110.948 11.236 111.172 11.0121 111.172 10.736L110.172 10.736ZM111.172 33.1504L111.172 29.9483L110.172 29.9483L110.172 33.1504L111.172 33.1504ZM111.172 23.5442L111.172 17.1401L110.172 17.1401L110.172 23.5442L111.172 23.5442ZM111.172 10.736L111.172 7.53395L110.172 7.53395L110.172 10.736L111.172 10.736Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.952 26.5963L174.136 63.288L152.952 99.9796L110.584 99.9796L89.3998 63.288L110.584 26.5963L152.952 26.5963Z",
    fill: "#FBF6FF",
    stroke: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.6424 68.0863L93.7918 87.3977L82.6424 106.709L60.3435 106.709L49.1941 87.3977L60.3435 68.0863L82.6424 68.0863Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.526316
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.6424 21.3734L93.7918 40.6848L82.6424 59.9962L60.3435 59.9962L49.1941 40.6848L60.3435 21.3734L82.6424 21.3734Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.526316
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.642 4.04526L203.792 23.3566L192.642 42.668L170.344 42.668L159.194 23.3566L170.344 4.04526L192.642 4.04526Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.526316
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M219.05 37.2267L224.962 47.4659L219.05 57.7052L207.227 57.7052L201.315 47.4659L207.227 37.2267L219.05 37.2267Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.401003
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.2826 9.34972L56.1943 19.589L50.2826 29.8282L38.4593 29.8282L32.5477 19.589L38.4594 9.34972L50.2826 9.34972Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.401003
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.734 62.8429L210.645 73.0821L204.734 83.3214L192.911 83.3214L186.999 73.0821L192.911 62.8429L204.734 62.8429Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.401003
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.747 1.81554L158.659 12.0548L152.747 22.294L140.924 22.294L135.013 12.0548L140.924 1.81554L152.747 1.81554Z",
    fill: "#D59DFF",
    stroke: "#A020FF",
    strokeWidth: 0.401003
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.96 60.4378C138.96 64.4159 135.745 67.6506 131.767 67.6506C127.789 67.6506 124.574 64.4159 124.574 60.4378C124.574 56.4598 127.789 53.2451 131.767 53.2451C135.745 53.2451 138.96 56.4598 138.96 60.4378Z",
    fill: "#B7CCFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.728 82.4345C141.158 82.831 139.301 83.014 137.124 83.014H126.415C124.237 83.014 122.381 82.831 120.811 82.4345C121.203 78.4692 125.969 75.3428 131.769 75.3428C137.57 75.3428 142.336 78.4692 142.728 82.4345Z",
    fill: "#A020FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.102 82.612C142.334 83.1344 140.244 83.3755 137.793 83.3755H125.738C123.287 83.3755 121.198 83.1344 119.43 82.612C119.872 77.3883 125.236 73.2695 131.766 73.2695C138.295 73.2695 143.66 77.3883 144.102 82.612Z",
    stroke: "#081E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.795 43.1934H125.74C115.694 43.1934 111.676 47.2116 111.676 57.2573V69.3121C111.676 76.9066 113.966 81.0655 119.431 82.6125C119.873 77.3888 125.237 73.27 131.767 73.27C138.297 73.27 143.661 77.3888 144.103 82.6125C149.568 81.0655 151.858 76.9066 151.858 69.3121V57.2573C151.858 47.2116 147.84 43.1934 137.795 43.1934ZM131.767 67.6445C127.789 67.6445 124.574 64.4098 124.574 60.4317C124.574 56.4537 127.789 53.239 131.767 53.239C135.745 53.239 138.96 56.4537 138.96 60.4317C138.96 64.4098 135.745 67.6445 131.767 67.6445Z",
    fill: "white",
    stroke: "#081E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.96 60.4378C138.96 64.4159 135.745 67.6506 131.767 67.6506C127.789 67.6506 124.574 64.4159 124.574 60.4378C124.574 56.4598 127.789 53.2451 131.767 53.2451C135.745 53.2451 138.96 56.4598 138.96 60.4378Z",
    stroke: "#081E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8878 93.8437L70.0215 93.8438",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6011 81.5576H75.1353C78.6932 81.5576 79.0489 83.2214 79.2896 85.2515L80.2314 93.0997C80.5349 95.6739 79.7396 97.7772 76.0771 97.7772H66.6697C62.9968 97.7772 62.2015 95.6739 62.5154 93.0997L63.4572 85.2515C63.6874 83.2214 64.0432 81.5576 67.6011 81.5576Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1836 83.1272V79.4647C67.1836 77.8951 68.23 76.8486 69.7997 76.8486H72.9389C74.5086 76.8486 75.555 77.8951 75.555 79.4647V83.1272",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8888 93.1455L65.9863 93.1455",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5051 87.7613C74.5051 88.0125 74.4737 88.2558 74.4109 88.4912C74.3403 88.8051 74.2147 89.1112 74.0499 89.3781C73.5084 90.2884 72.5117 90.9006 71.3658 90.9006C70.5575 90.9006 69.8276 90.5945 69.2782 90.0922C69.0428 89.8882 68.8387 89.6449 68.6817 89.3781C68.3914 88.9072 68.2266 88.35 68.2266 87.7613C68.2266 86.9137 68.564 86.1368 69.1134 85.5717C69.6863 84.9831 70.4868 84.6221 71.3658 84.6221C72.2919 84.6221 73.1317 85.0223 73.6967 85.6659C74.199 86.2231 74.5051 86.9608 74.5051 87.7613Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.538 87.7471H70.1992",
    stroke: "white",
    strokeWidth: 0.892857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3691 86.5996V88.9462",
    stroke: "white",
    strokeWidth: 0.892857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9453 42.695C60.9453 39.3801 60.9453 37.7227 62.1811 36.6929C63.4168 35.6631 65.4058 35.6631 69.3837 35.6631H73.6028C77.5807 35.6631 79.5697 35.6631 80.8054 36.6929C82.0412 37.7227 82.0412 39.3801 82.0412 42.695C82.0412 46.0099 82.0412 47.6674 80.8054 48.6972C79.5697 49.727 77.5807 49.727 73.6028 49.727H69.3837C65.4058 49.727 63.4168 49.727 62.1811 48.6972C60.9453 47.6674 60.9453 46.0099 60.9453 42.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1982 35.8031C63.3754 35.7111 63.5721 35.6631 63.7717 35.6631H78.6396C78.7993 35.6631 78.9575 35.6938 79.1056 35.7536L80.6302 36.3694C81.0299 36.5308 81.3176 36.8875 81.3907 37.3124L81.5389 38.1745H60.9453L61.4323 37.0381C61.5457 36.7736 61.7472 36.5565 62.0026 36.4239L63.1982 35.8031Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9453 42.695C60.9453 39.3801 60.9453 37.7227 62.1811 36.6929C63.4168 35.6631 65.4058 35.6631 69.3837 35.6631H73.6028C77.5807 35.6631 79.5697 35.6631 80.8054 36.6929C82.0412 37.7227 82.0412 39.3801 82.0412 42.695C82.0412 46.0099 82.0412 47.6674 80.8054 48.6972C79.5697 49.727 77.5807 49.727 73.6028 49.727H69.3837C65.4058 49.727 63.4168 49.727 62.1811 48.6972C60.9453 47.6674 60.9453 46.0099 60.9453 42.695Z",
    stroke: "#081E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5111 35.6628C75.5111 33.7686 75.5111 32.8215 74.9227 32.233C74.3342 31.6445 73.3871 31.6445 71.4929 31.6445C69.5986 31.6445 68.6515 31.6445 68.0631 32.233C67.4746 32.8215 67.4746 33.7686 67.4746 35.6628",
    stroke: "#081E54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.4948,
    cy: 43.6999,
    rx: 4.01826,
    ry: 4.01826,
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5046 43.7005H69.4863M71.4955 41.6914V45.7097",
    stroke: "white",
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.029 13.0673L182.001 13.1325L179.35 19.4044L177.015 19.3035C176.458 19.2794 175.92 19.389 175.426 19.6049L177.031 15.7076L177.068 15.6143L177.132 15.4652C177.151 15.4091 177.17 15.3529 177.196 15.3066C178.393 12.483 179.634 11.8819 182.029 13.0673Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.961 12.9581L182.931 13.0268L180.083 19.6363H177.284C176.616 19.6363 175.978 19.7738 175.398 20.0193L177.117 15.9142L177.156 15.816L177.225 15.6588C177.245 15.5999 177.264 15.541 177.294 15.4919C178.58 12.5161 180.034 11.8385 182.961 12.9581Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.255 19.8346C187.813 19.6971 187.342 19.6382 186.87 19.6382H180.084L182.932 13.0287L182.962 12.96C183.109 13.0091 183.246 13.0778 183.394 13.1367L185.564 14.0501C186.772 14.5509 187.617 15.0715 188.127 15.7C188.226 15.8178 188.304 15.9259 188.373 16.0535C188.461 16.191 188.53 16.3285 188.569 16.4758C188.609 16.5642 188.638 16.6526 188.658 16.7312C188.923 17.5561 188.766 18.5677 188.255 19.8346Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.665 24.4293V26.3444C191.665 26.5408 191.655 26.7372 191.645 26.9337C191.458 30.3612 189.543 32.0896 185.909 32.0896H178.249C178.013 32.0896 177.778 32.07 177.552 32.0405C174.429 31.8343 172.759 30.1647 172.553 27.0417C172.524 26.8158 172.504 26.5801 172.504 26.3444V24.4293C172.504 22.4553 173.702 20.7563 175.411 20.0197C176 19.7742 176.629 19.6367 177.297 19.6367H186.882C187.363 19.6367 187.834 19.7055 188.266 19.8331C190.221 20.4322 191.665 22.2589 191.665 24.4293Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.642 26V26.8544C183.642 27.5784 182.969 28.1634 182.14 28.1634C181.31 28.1634 180.633 27.5784 180.633 26.8544V26C180.633 26.7239 181.306 27.2374 182.14 27.2374C182.969 27.2374 183.642 26.7197 183.642 26Z",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.644 24.8399C183.644 25.0504 183.586 25.244 183.485 25.4123C183.236 25.8206 182.727 26.0774 182.138 26.0774C181.548 26.0774 181.039 25.8164 180.791 25.4123C180.69 25.244 180.631 25.0504 180.631 24.8399C180.631 24.478 180.799 24.1539 181.069 23.9182C181.342 23.6782 181.717 23.5352 182.133 23.5352C182.55 23.5352 182.925 23.6825 183.198 23.9182C183.476 24.1497 183.644 24.478 183.644 24.8399Z",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.642 24.8402V25.9977C183.642 26.7216 182.969 27.2351 182.14 27.2351C181.31 27.2351 180.633 26.7174 180.633 25.9977V24.8402C180.633 24.1163 181.306 23.5312 182.14 23.5312C182.556 23.5312 182.931 23.6786 183.205 23.9143C183.474 24.15 183.642 24.4783 183.642 24.8402Z",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.118 15.9131L175.399 20.0182C173.69 20.7548 172.492 22.4538 172.492 24.4278V21.5503C172.492 18.7612 174.476 16.4336 177.118 15.9131Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.66 21.552V24.4296C191.66 22.269 190.226 20.4324 188.262 19.8432C188.772 18.5665 188.92 17.5647 188.674 16.73C188.655 16.6416 188.625 16.5532 188.586 16.4746C190.412 17.4174 191.66 19.3521 191.66 21.552Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.523 30.6894C178.523 30.9925 178.486 31.286 178.41 31.5702C178.325 31.949 178.173 32.3183 177.974 32.6403C177.321 33.7388 176.118 34.4775 174.735 34.4775C173.76 34.4775 172.879 34.1081 172.216 33.502C171.932 33.2558 171.686 32.9623 171.497 32.6403C171.146 32.0721 170.947 31.3997 170.947 30.6894C170.947 29.6667 171.354 28.7291 172.017 28.0473C172.709 27.337 173.675 26.9014 174.735 26.9014C175.853 26.9014 176.866 27.3844 177.548 28.1609C178.154 28.8333 178.523 29.7235 178.523 30.6894Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.148 30.6719H173.326",
    stroke: "white",
    strokeWidth: 0.892857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.736 29.2861V32.1177",
    stroke: "white",
    strokeWidth: 0.892857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_602_39880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.875 50.1162V57.5089C212.875 58.2191 213.138 59.2737 214.434 59.2737C215.729 59.2737 216.06 58.2191 216.06 57.5089V52.8034C216.06 52.3721 216.279 51.5096 217.155 51.5096C218.03 51.5096 218.459 51.5096 218.691 51.5096",
    stroke: "#FF8165",
    strokeWidth: 0.388889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.01 46.5977C210.261 48.2795 211.419 49.6478 213.186 49.6478C214.516 49.6478 215.628 48.397 216.005 46.5977",
    stroke: "#1552E8",
    strokeWidth: 0.388889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.117 50.1162V57.5089C213.117 58.2191 213.38 59.2737 214.676 59.2737C215.972 59.2737 216.302 58.2191 216.302 57.5089V52.8034C216.302 52.3721 216.521 51.5096 217.397 51.5096C218.273 51.5096 218.701 51.5096 218.933 51.5096",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.834 42.5605V46.6411C209.867 47.769 210.551 50.0249 213.019 50.0249C215.487 50.0249 216.17 47.769 216.204 46.6411V42.5605",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.834 45.7637C210.199 46.4935 211.347 47.9532 213.019 47.9532C214.691 47.9532 215.839 46.4935 216.204 45.7637",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.833,
    cy: 41.6594,
    r: 1.20822,
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 0.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.202 42.8676C216.87 42.8676 217.411 42.3267 217.411 41.6594C217.411 40.9921 216.87 40.4512 216.202 40.4512C215.535 40.4512 214.994 40.9921 214.994 41.6594C214.994 42.3267 215.535 42.8676 216.202 42.8676Z",
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 0.625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.415,
    cy: 51.5024,
    r: 1.28648,
    stroke: "#081E54",
    strokeWidth: 0.388889
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.423,
    cy: 51.4908,
    r: 0.841426,
    fill: "#A020FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip1_602_39880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5053 14.3438H41.4784C39.7042 14.3438 39.3036 15.2309 39.0842 16.3278L38.2734 20.1909H49.7198L48.909 16.3278C48.6705 15.2309 48.2794 14.3438 46.5053 14.3438Z",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4975 18.998H41.4706C39.6964 18.998 38.7235 19.4262 38.5041 19.9519L38.2656 20.4288H49.712L49.4735 19.9519C49.235 19.4262 48.2716 18.998 46.4975 18.998Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.136 27.022C51.2122 27.5809 50.5451 28.0636 49.6874 28.0636H48.3437C47.5718 28.0636 47.467 27.8413 47.3241 27.5746L47.1811 27.2888C46.981 26.9013 47.1633 25.9174 46.1341 25.9174H43.9879H42.0802C41.051 25.9174 40.9772 26.9331 40.7962 27.2888L40.6532 27.5746C40.5198 27.8477 40.415 28.0636 39.6335 28.0636H38.2898C37.4322 28.0636 36.7556 27.5809 36.8413 27.022L37.2416 24.1194C37.3464 23.4017 37.5465 22.8174 39.4239 22.8174H48.5439C50.4212 22.8174 50.6214 23.4017 50.7262 24.1194L51.136 27.022Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1317 26.4952C51.208 27.3346 50.5403 28.0596 49.6818 28.0596H48.3369C47.5642 28.0596 47.4593 27.7257 47.3162 27.3251L47.1731 26.8959C46.9728 26.314 46.8393 25.9134 45.8091 25.9134H42.1463C41.1161 25.9134 40.9635 26.3617 40.7823 26.8959L40.6392 27.3251C40.5057 27.7352 40.4007 28.0596 39.6186 28.0596H38.2736C37.4151 28.0596 36.7379 27.3346 36.8238 26.4952L37.2244 22.1361C37.3293 21.0582 37.5296 20.1807 39.4087 20.1807H48.5372C50.4163 20.1807 50.6166 21.0582 50.7215 22.1361L51.1317 26.4952Z",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2662 18.0439H37.5508",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4263 18.0439H49.7109",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6973 23.7686H41.8435",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1348 23.7686H48.281",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7079 16.1622C51.9319 15.6422 51.8519 14.9383 51.4359 14.3223C51.0279 13.7063 50.4039 13.3623 49.8359 13.3703",
    stroke: "#081E54",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1948 16.9535C54.5308 15.7455 54.2908 14.2655 53.4348 12.9855C52.5788 11.7055 51.2988 10.9215 50.0508 10.7695",
    stroke: "#081E54",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip2_602_39880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.958 67.8379H195.932C194.157 67.8379 193.757 68.725 193.537 69.8219L192.727 73.6851H204.173L203.362 69.8219C203.124 68.725 202.733 67.8379 200.958 67.8379Z",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.951 72.4922H195.924C194.15 72.4922 193.177 72.9204 192.957 73.446L192.719 73.923H204.165L203.927 73.446C203.688 72.9204 202.725 72.4922 200.951 72.4922Z",
    fill: "#A020FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.589 80.5161C205.665 81.075 204.998 81.5578 204.141 81.5578H202.797C202.025 81.5578 201.92 81.3355 201.777 81.0687L201.634 80.7829C201.434 80.3955 201.616 79.4116 200.587 79.4116H198.441H196.533C195.504 79.4116 195.43 80.4272 195.249 80.7829L195.106 81.0687C194.973 81.3418 194.868 81.5578 194.087 81.5578H192.743C191.885 81.5578 191.209 81.075 191.294 80.5161L191.695 77.6135C191.8 76.8958 192 76.3115 193.877 76.3115H202.997C204.874 76.3115 205.074 76.8958 205.179 77.6135L205.589 80.5161Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.585 79.9894C205.661 80.8288 204.993 81.5537 204.135 81.5537H202.79C202.017 81.5537 201.912 81.2198 201.769 80.8192L201.626 80.39C201.426 79.8082 201.292 79.4075 200.262 79.4075H196.599C195.569 79.4075 195.417 79.8559 195.235 80.39L195.092 80.8192C194.959 81.2294 194.854 81.5537 194.072 81.5537H192.727C191.868 81.5537 191.191 80.8288 191.277 79.9894L191.678 75.6302C191.782 74.5523 191.983 73.6748 193.862 73.6748H202.99C204.869 73.6748 205.07 74.5523 205.175 75.6302L205.585 79.9894Z",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.719 71.5381H192.004",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.879 71.5381H204.164",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.15 77.2627H196.297",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.588 77.2627H202.734",
    stroke: "#081E54",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.161 69.6564C206.385 69.1364 206.305 68.4324 205.889 67.8164C205.481 67.2004 204.857 66.8564 204.289 66.8644",
    stroke: "#081E54",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.648 70.4477C208.984 69.2397 208.744 67.7597 207.888 66.4797C207.032 65.1997 205.752 64.4157 204.504 64.2637",
    stroke: "#081E54",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.276 14.6048C150.575 13.6431 152.985 11.0657 152.985 9.30626C152.985 7.73866 151.647 6.46777 149.998 6.46777C148.89 6.46777 147.925 7.04266 147.409 7.89421C146.894 7.04266 145.929 6.46777 144.821 6.46777C143.171 6.46777 141.834 7.73866 141.834 9.30626C141.834 10.5728 143.083 12.2634 144.267 13.4697",
    fill: "#E4C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.203 15.4476L141.337 14.874L143.228 17.9403L142.068 18.6555",
    fill: "#FF8165"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.203 15.1275L141.468 14.4961L143.578 17.8717L142.283 18.659",
    stroke: "#081E54",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.69 14.9183L148.219 14.9168C148.685 14.9168 149.062 14.5394 149.062 14.0735C149.062 13.6079 148.685 13.2305 148.219 13.2305L144.994 13.2319C144.621 13.2319 144.254 13.3311 143.932 13.5191L141.895 14.7075",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.69 14.9183L148.219 14.9168C148.685 14.9168 149.062 14.5394 149.062 14.0735C149.062 13.6079 148.685 13.2305 148.219 13.2305L144.994 13.2319C144.621 13.2319 144.254 13.3311 143.932 13.5191L141.895 14.7075",
    stroke: "#081E54",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.431 14.9146L152.119 13.2964C152.548 13.1186 153.044 13.3243 153.222 13.753C153.399 14.1819 153.194 14.6781 152.765 14.8557L149.037 16.6463C148.777 16.7564 148.497 16.8134 148.214 16.8134H144.901C144.671 16.8134 144.446 16.8756 144.25 16.9935L143.496 17.4461",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.431 14.9146L152.119 13.2964C152.548 13.1186 153.044 13.3243 153.222 13.753C153.399 14.1819 153.194 14.6781 152.765 14.8557L149.037 16.6463C148.777 16.7564 148.497 16.8134 148.214 16.8134H144.901C144.671 16.8134 144.446 16.8756 144.25 16.9935L143.496 17.4461",
    stroke: "#081E54",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.356 14.4947C150.732 13.4226 153.285 10.5491 153.285 8.58746C153.285 6.83975 151.868 5.42285 150.121 5.42285C148.947 5.42285 147.924 6.06379 147.378 7.01317C146.832 6.06379 145.809 5.42285 144.635 5.42285C142.888 5.42285 141.471 6.83975 141.471 8.58746C141.471 9.99951 142.794 11.8844 144.049 13.2293",
    stroke: "#081E54",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.4531 63.7881L0.67231 63.7881",
    stroke: "#A020FF",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.33 57.7607L224.44 57.7607",
    stroke: "#A020FF",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.109 99.3291C151.833 99.3291 151.609 99.553 151.609 99.8291C151.609 100.105 151.833 100.329 152.109 100.329V99.3291ZM155.274 100.329C155.55 100.329 155.774 100.105 155.774 99.8291C155.774 99.553 155.55 99.3291 155.274 99.3291V100.329ZM161.603 99.3291C161.326 99.3291 161.103 99.553 161.103 99.8291C161.103 100.105 161.326 100.329 161.603 100.329V99.3291ZM167.931 100.329C168.207 100.329 168.431 100.105 168.431 99.8291C168.431 99.553 168.207 99.3291 167.931 99.3291V100.329ZM174.26 99.3291C173.984 99.3291 173.76 99.553 173.76 99.8291C173.76 100.105 173.984 100.329 174.26 100.329V99.3291ZM180.589 100.329C180.865 100.329 181.089 100.105 181.089 99.8291C181.089 99.553 180.865 99.3291 180.589 99.3291V100.329ZM186.918 99.3291C186.641 99.3291 186.418 99.553 186.418 99.8291C186.418 100.105 186.641 100.329 186.918 100.329V99.3291ZM193.246 100.329C193.522 100.329 193.746 100.105 193.746 99.8291C193.746 99.553 193.522 99.3291 193.246 99.3291V100.329ZM199.575 99.3291C199.299 99.3291 199.075 99.553 199.075 99.8291C199.075 100.105 199.299 100.329 199.575 100.329V99.3291ZM205.904 100.329C206.18 100.329 206.404 100.105 206.404 99.8291C206.404 99.553 206.18 99.3291 205.904 99.3291V100.329ZM212.233 99.3291C211.957 99.3291 211.733 99.553 211.733 99.8291C211.733 100.105 211.957 100.329 212.233 100.329V99.3291ZM152.109 100.329H155.274V99.3291H152.109V100.329ZM161.603 100.329H167.931V99.3291H161.603V100.329ZM174.26 100.329H180.589V99.3291H174.26V100.329ZM186.918 100.329H193.246V99.3291H186.918V100.329ZM199.575 100.329H205.904V99.3291H199.575V100.329ZM212.233 100.329H215.397V99.3291H212.233V100.329Z",
    fill: "#A020FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8086 63.7881H66.973",
    stroke: "#B756FF",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_39880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0685,
    height: 15.0685,
    fill: "white",
    transform: "translate(205.604 39.9316)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_602_39880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0685,
    height: 15.0685,
    fill: "white",
    transform: "translate(36.8359 12.0547)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_602_39880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0685,
    height: 15.0685,
    fill: "white",
    transform: "translate(191.289 65.5488)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapySearch);
export default __webpack_public_path__ + "static/media/TherapySearch.bf7d3213385a25b8b88aee194413755d.svg";
export { ForwardRef as ReactComponent };